<template>
  <div>
    <v-row justify="center">
      <v-col cols="12">
        <v-card class="rounded-lg elevation-3 overflow-hidden">
          <!-- Toolbar Header Principal -->
          <v-toolbar color="secondary" dark flat class="table-header-toolbar px-2 px-sm-3">
            <div class="d-flex align-center header-main-info flex-grow-1 min-width-0">
              <div class="header-icon-box mr-2 mr-sm-3 flex-shrink-0">
                <v-icon color="white">mdi-clipboard-check-outline</v-icon>
              </div>
              <div class="header-text-block min-width-0 mr-2 mr-sm-3">
                <div class="header-company-title font-weight-bold text-truncate">
                  {{ Titulo || "Reporte de Inspecciones" }}
                </div>
              </div>
              <v-chip
                small
                color="white"
                text-color="secondary"
                class="header-count-chip font-weight-bold elevation-1 flex-shrink-0"
              >
                <v-icon left size="16" color="secondary">mdi-counter</v-icon>
                {{ ItemTotal || total || (data ? data.length : 0) }}
              </v-chip>
            </div>

            <div class="header-help-btn ml-1 ml-sm-2 flex-shrink-0">
              <!-- Botón de Ayuda -->
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="mx-1 btn-circle-tooltip"
                    icon
                    dark
                    target="_blank"
                    :href="global.helpdesk_url + 'reporte_inspeccion'"
                    v-on="on"
                  >
                    <v-icon size="25" color="amber lighten-2"
                      >mdi-help-circle-outline</v-icon
                    >
                  </v-btn>
                </template>
                <span>¿Necesitas ayuda?</span>
              </v-tooltip>
            </div>
          </v-toolbar>

          <!-- Sección de Filtros y Acciones -->
          <div class="pa-2 pa-sm-4 pb-2">
            <!-- Fila 1: Filtros de Búsqueda y Rango de Fechas -->
            <v-row dense class="align-center mb-2">
              <!-- Búsqueda General -->
              <v-col cols="12" md="6" lg="6">
                <v-text-field
                  v-model="search"
                  @input="ActualizarListadoAgregado"
                  outlined
                  dense
                  single-line
                  hide-details
                  prepend-inner-icon="mdi-magnify"
                  clearable
                  label="Búsqueda rápida"
                  placeholder="Buscar por placa, código de inspección, inspector..."
                  class="rounded-lg"
                ></v-text-field>
              </v-col>

              <!-- Fecha Desde -->
              <v-col cols="12" sm="6" md="3" lg="3">
                <v-menu
                  ref="menufechadesde"
                  v-model="menufechadesde"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fechadesdeform"
                      outlined
                      dense
                      hide-details="auto"
                      @input="
                        fechaDesde = null;
                        ActualizarListadoAgregado();
                      "
                      label="Fecha Desde"
                      prepend-inner-icon="mdi-calendar-start"
                      readonly
                      clearable
                      v-bind="attrs"
                      v-on="on"
                      class="rounded-lg"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    no-title
                    scrollable
                    color="primary"
                    v-model="fechaDesde"
                    :max="fechaHasta"
                    @input="
                      menufechadesde = false;
                      fechadesdeform = formateadofecha(fechaDesde);
                      ActualizarListadoAgregado();
                    "
                    locale="es-pe"
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>

              <!-- Fecha Hasta -->
              <v-col cols="12" sm="6" md="3" lg="3">
                <v-menu
                  ref="menufechahasta"
                  v-model="menufechahasta"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                  left
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fechahastaform"
                      outlined
                      dense
                      hide-details="auto"
                      label="Fecha Hasta"
                      @input="
                        fechaHasta = null;
                        ActualizarListadoAgregado();
                      "
                      prepend-inner-icon="mdi-calendar-end"
                      readonly
                      clearable
                      v-bind="attrs"
                      v-on="on"
                      class="rounded-lg"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    no-title
                    scrollable
                    color="primary"
                    v-model="fechaHasta"
                    @input="
                      menufechahasta = false;
                      fechahastaform = formateadofecha(fechaHasta);
                      ActualizarListadoAgregado();
                    "
                    :min="fechaDesde"
                    locale="es-pe"
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>

            <!-- Fila 2: Botones de Acción -->
            <div
              class="action-buttons-group d-flex align-center justify-end flex-wrap gap-2 mb-3"
            >
              <!-- Botón Nuevo -->
              <v-btn
                v-if="
                  global._autorizacion_usuario(Permisos, $route.meta.id, ['2'])
                "
                color="primary"
                dark
                height="38"
                class="btn-action-header px-4 font-weight-bold elevation-1 text-none rounded-lg mr-sm-2"
                @click="nuevoItem()"
              >
                <v-icon left size="20">mdi-plus-circle</v-icon>
                Nueva Inspección
              </v-btn>

              <!-- Menú Exportar Rápido -->
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="secondary"
                    outlined
                    height="38"
                    class="btn-action-header px-4 font-weight-bold text-none rounded-lg mr-sm-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon left size="18">mdi-file-export-outline</v-icon>
                    Exportar
                    <v-icon right small>mdi-chevron-down</v-icon>
                  </v-btn>
                </template>
                <v-list dense class="py-1">
                  <v-list-item
                    v-for="item in opcionesAexportar"
                    :key="item.id"
                    @click="exportarAExcel1(item.text)"
                    class="px-3"
                  >
                    <v-list-item-icon class="mr-2 my-1">
                      <v-icon small color="success">mdi-file-excel</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title class="text-caption font-weight-medium">
                      {{ item.text }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <!-- Botón Exportar General -->
              <v-btn
                color="success"
                dark
                height="38"
                class="btn-action-header px-4 font-weight-bold elevation-1 text-none rounded-lg"
                @click="
                  dialogexport = true;
                  loadingExportgeneral = false;
                "
              >
                <v-icon left size="18">mdi-file-excel</v-icon>
                Exportar General
              </v-btn>
            </div>
          </div>

          <!-- Indicador de desplazamiento horizontal en celular -->
          <div
            class="d-flex d-sm-none align-center text-caption primary--text mb-2 px-3 pt-1"
          >
            <v-icon x-small color="primary" class="mr-1">
              mdi-gesture-swipe-horizontal
            </v-icon>
            <span>Desliza horizontalmente para ver todos los datos</span>
          </div>

          <!-- Tabla de Datos Principal con Header Oscuro y Botones Estilizados -->
          <div class="table-responsive-wrapper">
            <v-data-table
              dense
              :headers="Cabecera"
              :items="loading ? [] : data"
              :loading="loading"
              :mobile-breakpoint="0"
              class="elevation-0 modern-table"
              no-data-text="No hay datos de inspección disponibles"
              :items-per-page="Number(per_page)"
              :page="Number(page)"
              :server-items-length="total"
              :footer-props="{
                'items-per-page-options': [10, 25, 50, 100],
                'items-per-page-text': 'Resultados por página:',
                'page-text': `${from != null ? from : 0}-${
                  to != null ? to : 0
                } de ${from == null ? 0 : total}`,
                'disable-page-before': loading,
                disablePagination: loading,
                disableItemsPerPage: loading,
              }"
              @update:options="ActualizarListado"
              :item-class="GetClass"
            >
              <template v-slot:loading>
                <v-skeleton-loader :type="'table-row@1'"></v-skeleton-loader>
              </template>

              <!-- Acciones por fila -->
              <template v-slot:[`item.acciones`]="{ item }">
                <div class="d-flex align-center justify-center gap-1">
                  <v-tooltip
                    bottom
                    v-if="
                      global._autorizacion_usuario(Permisos, $route.meta.id, [
                        '3',
                      ])
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        height="24"
                        width="24"
                        color="blue lighten-2"
                        fab
                        x-small
                        dark
                        class="action-btn elevation-1"
                        @click="editarItem(item)"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon x-small>mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        height="24"
                        width="24"
                        color="#FE9B2F"
                        fab
                        x-small
                        dark
                        class="action-btn elevation-1 ml-1"
                        @click="detallesItem(item)"
                        :loading="item.loader"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon x-small>mdi-format-list-bulleted</v-icon>
                      </v-btn>
                    </template>
                    <span>Detalles</span>
                  </v-tooltip>
                </div>
              </template>
            </v-data-table>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Modal Registro / Edición de Inspección -->
    <v-dialog
      v-model="dialognuevo"
      max-width="980px"
      scrollable
      @click:outside="cerrarModalNuevo"
    >
      <Nuevo
        :Item="itemSelected"
        :Cliente="Cliente"
        @cargarPosiciones="cargarPosiciones"
        @editarInspeccion="editarInspeccionMinified"
        @fechavalida="fechavalida"
        @cerrarModalNuevo="cerrarModalNuevo"
      >
      </Nuevo>
    </v-dialog>

    <!-- Modal para Exportar General con fechas y opciones -->
    <v-dialog
      v-model="dialogexport"
      max-width="520px"
      @click:outside="cerrarModalExport()"
    >
      <v-card class="rounded-lg elevation-4 overflow-hidden">
        <v-toolbar color="secondary" dark dense flat height="50" class="px-3">
          <v-icon left small>mdi-file-excel</v-icon>
          <span class="text-subtitle-1 font-weight-bold"
            >Exportar Reporte General</span
          >
          <v-spacer></v-spacer>
          <v-btn icon dark small @click="cerrarModalExport()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-4 pt-5">
          <p class="text-caption grey--text text--darken-2 mb-3">
            Seleccione el rango de fechas para generar el archivo de
            exportación:
          </p>
          <v-row dense>
            <v-col cols="12" sm="6" class="pa-1">
              <v-menu
                ref="menufechaini"
                v-model="menufechaini"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="fechainiform"
                    label="Fecha Inicio"
                    prepend-inner-icon="mdi-calendar-start"
                    readonly
                    outlined
                    dense
                    hide-details="auto"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  no-title
                  scrollable
                  color="primary"
                  v-model="fechaInicio"
                  :max="fechamaxini"
                  @input="
                    menufechaini = false;
                    fechainiform = formateadofecha(fechaInicio);
                  "
                  locale="es-pe"
                >
                </v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="6" class="pa-1">
              <v-menu
                ref="menufechafin"
                v-model="menufechafin"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="fechafinform"
                    label="Fecha Fin"
                    prepend-inner-icon="mdi-calendar-end"
                    readonly
                    outlined
                    dense
                    hide-details="auto"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  no-title
                  scrollable
                  color="primary"
                  v-model="fechaFinal"
                  @input="
                    menufechafin = false;
                    fechafinform = formateadofecha(fechaFinal);
                  "
                  :min="fechaInicio"
                  :max="fechamaxfin"
                  locale="es-pe"
                >
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions
          class="bg-actions pa-3 px-4 d-flex flex-wrap align-center"
        >
          <v-btn
            text
            color="grey darken-1"
            class="text-capitalize"
            :disabled="loadingExportgeneral"
            @click="cerrarModalExport()"
          >
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            v-for="item in opcionesAexportar"
            :key="item.id"
            :disabled="loadingExportgeneral"
            color="primary"
            elevation="1"
            class="text-capitalize px-3 ml-2 mb-1"
            @click="exportarAExcel2(item.text)"
          >
            <v-icon left small>{{
              item.id === 1 ? "mdi-file-excel" : "mdi-file-delimited"
            }}</v-icon>
            {{ item.text }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal Detalles de Inspección -->
    <v-dialog
      v-model="dialogdetalles"
      width="1250"
      scrollable
      @click:outside="cerrarModalDetallesPorIdentificador"
    >
      <TablaDetalles
        :Inspecciones="Inspecciones"
        :Vehiculo="vehiculoSeleccionado"
        @editarInspeccionParcial="editarInspeccionParcial"
        @cerrarModalDetallesPorIdentificador="
          cerrarModalDetallesPorIdentificador
        "
        :Identificador="identificador"
        :mostrarBotonEliminar="false"
        v-if="verTablaDetalles"
      />
    </v-dialog>

    <!-- Modal Detalle Eje/Neumático -->
    <Detalle
      ref="detalle"
      :dialog="dialog"
      :Item="itemSelected"
      :Ejes="Ejes"
      :MotivosInaccesibilidad="MotivosInaccesibilidad"
      :TiposValvula="TiposValvula"
      :Duales="duales"
      :Observaciones="Observaciones"
      @agregarInspeccionParcial="agregarInspeccionParcial"
      @cerrarModal="cerrarModal"
      v-if="dialog"
    />
  </div>
</template>

<script>
import Nuevo from "./nuevo.vue";
// import axios from "axios";
import { axios2 as axios } from "@/interceptor/useApi";
import TablaDetalles from "@/components/inspeccion/detalles.vue";
import Detalle from "@/components/inspeccion/detalle.vue";
import global from "@/global";
import { notif } from "@/plugins/notyf";

import { mapState, mapActions } from "vuex";
import moment from "moment";

export default {
  props: [
    "Titulo",
    "Cabecera",
    "loading",
    "Items",
    "ItemTotal",
    "total",
    "Excel",
    "Crear",
    "data",
    "from",
    "to",
    "per_page",
    "page",
  ],
  emits: ["getInspecciones"],
  components: {
    Nuevo,
    Detalle,
    TablaDetalles,
  },
  data() {
    return {
      search: "",
      itemSelected: {},
      Inspecciones: [],
      loader: false,
      dialog: false,
      dialogexport: false,
      dialognuevo: false,
      dialogdetalles: false,
      duales: [
        {
          opcion: false,
          text: "Diseño",
        },
        {
          opcion: false,
          text: "Tamaño",
        },
        {
          opcion: false,
          text: "Tipo de Construcción",
        },
        {
          opcion: false,
          text: "Medida de Neumático",
        },
        {
          opcion: false,
          text: "No Aplica",
        },
      ],
      identificador: "",
      vehiculoSeleccionado: null,
      mostrarTabla: true,
      verTablaDetalles: false,
      opcionesAexportar: [
        {
          id: 1,
          text: "Exportar Excel",
        },
        {
          id: 2,
          text: "Exportar CSV",
        },
      ],
      loadingExport: false,
      loadingExportgeneral: false,
      fechainiform: moment().format("DD/MM/YYYY"),
      fechafinform: moment().format("DD/MM/YYYY"),
      fechaInicio: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menufechaini: false,
      fechaFinal: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menufechafin: false,
      fechaminini: moment().format("YYYY-MM-DD"),
      fechamaxini: moment().format("YYYY-MM-DD"),
      fechaminfin: moment().format("YYYY-MM-DD"),
      fechamaxfin: moment().format("YYYY-MM-DD"),
      cantmesmax_export: 12,
      global: global,
      pageLocal: Number(this.page) || 1,
      perPageLocal: Number(this.per_page) || 10,
      sortByLocal: "id",
      sortDescLocal: "DESC",
      fechadesdeform: null,
      fechahastaform: null,
      fechaDesde: null,
      menufechadesde: false,
      fechaHasta: null,
      menufechahasta: false,
      fechamindesde: moment().format("YYYY-MM-DD"),
      fechamaxdesde: moment().format("YYYY-MM-DD"),
      fechaminhasta: moment().format("YYYY-MM-DD"),
      fechamaxhasta: moment().format("YYYY-MM-DD"),
    };
  },
  watch: {
    dialogexport(val) {
      (this.fechafinform = moment().format("DD/MM/YYYY")),
        (this.loadingExportgeneral = false);
      (this.menufechaini = false),
        (this.menufechafin = false),
        (this.fechaFinal = new Date(
          Date.now() - new Date().getTimezoneOffset() * 60000,
        )
          .toISOString()
          .substr(0, 10)),
        (this.fechaInicio = new Date(
          Date.now() - new Date().getTimezoneOffset() * 60000,
        )
          .toISOString()
          .substr(0, 10)),
        (this.fechainiform = moment().format("DD/MM/YYYY")),
        (this.fechaminini = moment().format("YYYY-MM-DD")),
        (this.fechamaxini = moment().format("YYYY-MM-DD")),
        (this.fechaminfin = moment().format("YYYY-MM-DD")),
        (this.fechamaxfin = moment().format("YYYY-MM-DD")),
        this.$nextTick().then(() => {
          this.mostrarTabla = true;
        });
    },
    fechaInicio(val) {
      if (val) {
        const fechainic = new Date(val);

        // Restar el número de meses especificado (24 meses en este caso)
        fechainic.setMonth(fechainic.getMonth() + this.cantmesmax_export);

        if (
          this.fechamaxfin > fechainic.toISOString().split("T")[0] ||
          this.fechamaxfin < this.fechaInicio
        ) {
          // Convertir a formato YYYY-MM-DD y asignar a fechaminini
          if (
            fechainic.toISOString().split("T")[0] >
            moment().format("YYYY-MM-DD")
          ) {
            this.fechamaxfin = moment().format("YYYY-MM-DD");
          } else {
            this.fechamaxfin = fechainic.toISOString().split("T")[0];
          }
        }

        if (this.fechaInicio > this.fechaFinal) {
          this.fechaminfin = this.fechaInicio;
          this.fechaFinal = this.fechaInicio;

          this.fechafinform = moment(this.fechaInicio).format("DD/MM/YYYY");
        }

        // Comparar si la fecha mínima es mayor que la fecha de inicio
        if (this.fechaFinal && this.fechamaxfin <= this.fechaFinal) {
          // Si la fecha mínima es mayor, ajustar la fecha de inicio
          this.fechaFinal = this.fechamaxfin;
          this.fechafinform = moment(this.fechaFinal).format("DD/MM/YYYY");
        }
      }
    },
  },
  created() {
    this.ObtenerDatosCliente();
    this.cargarDatosAdicionales();
  },
  computed: {
    ...mapState("cliente", ["Cliente"]),
    ...mapState("inspeccion", [
      "Ejes",
      "MotivosInaccesibilidad",
      "TiposValvula",
      "Observaciones",
    ]),
    ...mapState("navigation", ["Permisos"]),
    // Lista de observaciones dinámica desde el store (grupos [{tipo, nombre, items[]}])
    observacionesConOpcion() {
      if (!Array.isArray(this.Observaciones)) return [];
      return this.Observaciones.map((g) => ({
        ...g,
        name: g.nombre || g.tipo,
        text: g.nombre || g.tipo,
        opcion: false,
      }));
    },
  },
  methods: {
    ...mapActions("cliente", ["ObtenerDatosCliente"]),
    ...mapActions("inspeccion", [
      "cargarInspecciones",
      "cargarInspeccionesPorIdentificador",
      "cargarDatosAdicionales",
    ]),

    formateadofecha(fecha) {
      if (!fecha) return null;

      const [year, month, day] = fecha.split("-");
      return `${day}/${month}/${year}`;
    },
    validateFechaFinal: function () {
      if (this.fechaFinal && this.fechaInicio) {
        return this.fechaFinal >= this.fechaInicio;
      }
      return true;
    },
    cargarPosiciones: function () {},

    fechavalida: function (fecha) {
      this.itemSelected.fecha_inspeccion = fecha;
    },

    editarItem: function (item) {
      this.itemSelected = {
        ...item,
      };
      this.itemSelected.codigo =
        this.itemSelected.insp_codigo == "-"
          ? null
          : this.itemSelected.insp_codigo;
      this.itemSelected.repuesto =
        this.itemSelected.repuesto == null ? 0 : this.itemSelected.repuesto;
      this.itemSelected.portallantas =
        this.itemSelected.portallantas == null
          ? 0
          : this.itemSelected.portallantas;
      this.dialognuevo = true;
    },

    detallesItem: async function (item) {
      item.loader = true;
      this.verTablaDetalles = true;
      this.vehiculoSeleccionado = item.vehiculo || item.vehiculos || item;
      this.identificador = item.identificador;
      let array_id_inspecciones = await this.cargarInspeccionesPorIdentificador(
        this.identificador,
      );
      try {
        const url = "inspecciones/obtenerInspeccionesParcial";
        const data = {
          id_cliente: localStorage.getItem("idcliente"),
          array_id_inspecciones: array_id_inspecciones,
        };
        await axios
          .post(url, data)
          .then((response) => {
            this.Inspecciones = response.data.inspecciones;
            item.loader = false;
            this.dialogdetalles = false;
            this.$nextTick().then(() => {
              this.dialogdetalles = true;
            });
          })
          .catch((error) => {
            this.errorMessage = error.response.data;
            console.error("error!", error);
          });
      } catch (error) {
        console.log(error);
      }
    },

    cerrarModalDetallesPorIdentificador: function () {
      this.mostrarTabla = false;
      this.verTablaDetalles = false;
      this.dialogdetalles = false;
      this.$nextTick().then(() => {
        this.mostrarTabla = true;
      });
    },

    cerrarModalExport: function () {
      this.dialogexport = false;
      (this.fechainiform = moment().format("DD/MM/YYYY")),
        (this.fechafinform = moment().format("DD/MM/YYYY")),
        (this.loadingExportgeneral = false);
      (this.fechaInicio = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000,
      )
        .toISOString()
        .substr(0, 10)),
        (this.menufechaini = false),
        (this.menufechafin = false),
        (this.fechaFinal = new Date(
          Date.now() - new Date().getTimezoneOffset() * 60000,
        )
          .toISOString()
          .substr(0, 10)),
        this.$nextTick().then(() => {
          this.mostrarTabla = true;
        });
    },

    cerrarModalNuevo: function () {
      this.mostrarTabla = false;
      this.dialognuevo = false;
      this.$nextTick().then(() => {
        this.mostrarTabla = true;
      });
    },

    editarInspeccionParcial: function (item) {
      this.itemSelected = { ...item };
      // Resetear duales
      this.duales.forEach((element) => {
        element.opcion = false;
      });

      item.array_resultado.forEach((element1) => {
        this.duales.forEach((element2) => {
          if (element1 == element2.text) element2.opcion = true;
        });
      });

      this.duales = [...this.duales];
      this.dialog = true;
    },

    agregarInspeccionParcial: async function (id) {
      // Recargar detalles de la inspección
      const idf = this.itemSelected?.identificador || this.identificador;
      if (idf) {
        this.detallesItem({
          identificador: idf,
          vehiculo: this.vehiculoSeleccionado,
        });
      }
      this.dialog = false;
    },

    editarInspeccionMinified: async function (item) {
      this.cerrarModalNuevo();
      this.$emit("getInspecciones", {
        page: this.pageLocal,
        per_page: this.perPageLocal,
        search: this.search,
        date_init: this.fechaDesde,
        date_end: this.fechaHasta,
        sortBy: this.sortByLocal,
        sortDirection: this.sortDescLocal,
      });
    },

    cerrarModal: function () {
      this.dialog = false;
    },

    async exportarAExcel1(extension1) {
      try {
        this.loadingExport = true;
        // Crear notificación de carga con spinner
        const loadingNotification = notif.open({
          type: "info",
          message:
            '<div style="display:flex;align-items:center;gap:10px;"><div class="export-spinner"></div><span style="color:#333;font-size:14px;font-weight:500;">Exportando Inspecciones...</span></div>',
          duration: 0,
          dismissible: false,
          className: "loading-notification",
        });

        // Agregar estilo para spinner
        const style = document.createElement("style");
        style.innerHTML = `
          .export-spinner {
            border: 3px solid #e0e0e0;
            border-top: 3px solid #1976d2;
            border-radius: 50%;
            width: 22px;
            height: 22px;
            min-width: 22px;
            animation: export-spin 1s linear infinite;
          }
          @keyframes export-spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          .loading-notification .noty_body {
            display: flex;
            align-items: center;
          }
        `;
        document.head.appendChild(style);
        const url =
          global.ruta_api +
          "excel/reporteinspeccionesminified?" +
          global._json_to_query_string({
            id_cliente: localStorage.getItem("idcliente"),
            extension: extension1,
          });

        await axios({ url: url, method: "GET", responseType: "blob" })
          .then(async (response) => {
            this.loadingExport = false;
            console.log("loading2", this.loadingExport);
            var nombre_archivo = response.headers["nombre-archivo"];
            loadingNotification && notif.dismiss(loadingNotification);
            if (response.data.type == "text/html") {
              // no es excel, probablemente es json con un mensaje de error
              const res = JSON.parse(await response.data.text());
              if (!res.exito) {
                alert(res.mensaje || "Sucedió un error, intentelo nuevamente");
              }
            } else {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", nombre_archivo);
              document.body.appendChild(link);
              link.click();
              // Mostrar notificación de éxito y cerrar la notificación de carga
              notif.success("Archivo exportado correctamente");
            }
          })
          .catch((error) => {
            this.errorMessage = error.response.data;
            console.error("error!", error);
            loadingNotification && notif.dismiss(loadingNotification);
          });
      } catch (error) {
        console.log(error);
      }
    },

    async exportarAExcel2(extension2) {
      try {
        this.loadingExportgeneral = true;
        const url =
          global.ruta_api +
          "excel/reporteinspecciones?" +
          global._json_to_query_string({
            id_cliente: localStorage.getItem("idcliente"),
            id_usuario: localStorage.getItem("id"),
            fechaini: this.fechaInicio,
            fechafin: this.fechaFinal,
            extension: extension2,
          });

        // Crear notificación de carga con spinner
        const loadingNotification = notif.open({
          type: "info",
          message:
            '<div style="display:flex;align-items:center;gap:10px;"><div class="export-spinner"></div><span style="color:#333;font-size:14px;font-weight:500;">Exportando Inspecciones...</span></div>',
          duration: 0,
          dismissible: false,
          className: "loading-notification",
        });

        // Agregar estilo para spinner
        const style = document.createElement("style");
        style.innerHTML = `
          .export-spinner {
            border: 3px solid #e0e0e0;
            border-top: 3px solid #1976d2;
            border-radius: 50%;
            width: 22px;
            height: 22px;
            min-width: 22px;
            animation: export-spin 1s linear infinite;
          }
          @keyframes export-spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          .loading-notification .noty_body {
            display: flex;
            align-items: center;
          }
        `;
        document.head.appendChild(style);
        await axios({ url: url, method: "GET", responseType: "blob" })
          .then(async (response) => {
            this.loadingExportgeneral = false;
            var nombre_archivo = response.headers["nombre-archivo"];
            loadingNotification && notif.dismiss(loadingNotification);
            if (response.data.type == "text/html") {
              // no es excel, probablemente es json con un mensaje de error
              const res = JSON.parse(await response.data.text());
              if (!res.exito) {
                alert(res.mensaje || "Sucedió un error, intentelo nuevamente");
              }
            } else {
              this.dialogexport = false;
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", nombre_archivo);
              document.body.appendChild(link);
              link.click();
              // Mostrar notificación de éxito y cerrar la notificación de carga
              notif.success("Archivo exportado correctamente");
            }
          })
          .catch((error) => {
            this.errorMessage = error.response.data;
            console.error("error!", error);
            loadingNotification && notif.dismiss(loadingNotification);
          });
      } catch (error) {
        console.log(error);
      }
    },
    ActualizarListado({ page, itemsPerPage, sortBy, sortDesc }) {
      this.pageLocal = page ? page : 1;
      this.perPageLocal = itemsPerPage ? itemsPerPage : 10;
      this.sortByLocal = sortBy.length != 0 ? sortBy[0] : "identificador";
      this.sortDescLocal =
        sortDesc.length == 0 ? "DESC" : sortDesc[0] ? "ASC" : "DESC";
      this.$emit("getInspecciones", {
        page: page ? page : 1,
        per_page: itemsPerPage ? itemsPerPage : 10,
        search: this.search,
        date_init: this.fechaDesde,
        date_end: this.fechaHasta,
        sortBy: sortBy.length != 0 ? sortBy[0] : "identificador",
        sortDirection:
          sortDesc.length == 0 ? "DESC" : sortDesc[0] ? "ASC" : "DESC",
      });
    },
    ActualizarListadoAgregado() {
      this.$emit("getInspecciones", {
        page: 1,
        per_page: this.perPageLocal ? this.perPageLocal : 10,
        search: this.search,
        date_init: this.fechaDesde,
        date_end: this.fechaHasta,
        sortBy: this.sortByLocal ? this.sortByLocal : "identificador",
        sortDirection: this.sortDescLocal ? this.sortDescLocal : "DESC",
      });
    },
    GetClass(item) {
      return item.flag_id && item.flag_id != null ? "bg-gray-light" : "";
    },
  },
};
</script>

<style>
.v-date-picker-table--date th {
  border: none !important;
  background-color: transparent !important;
  color: inherit !important;
}

.v-date-picker-table td button {
  border: none !important;
  background-color: transparent !important;
}
</style>

<style scoped>
/* Toolbar y Header Responsive */
.table-header-toolbar {
  min-height: 56px;
}

.table-header-toolbar ::v-deep .v-toolbar__content {
  padding: 8px 14px !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-main-info {
  display: flex;
  align-items: center;
  min-width: 0;
  overflow: hidden;
}

.header-icon-box {
  width: 38px;
  height: 38px;
  min-width: 38px;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-text-block {
  min-width: 0;
  overflow: hidden;
}

.header-company-title {
  font-size: 1.1rem;
  line-height: 1.25;
  letter-spacing: 0.3px;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header-count-chip {
  font-size: 0.85rem !important;
  height: 28px !important;
}

.bg-actions {
  background-color: #f8fafc;
  border-top: 1px solid #e2e8f0;
}

.bg-gray-light {
  background-color: #ffe7a9 !important;
}

/* Header Oscuro y Estilo de Tabla de vehiculos/tabla.vue */
.modern-table {
  border-top: 1px solid #e2e8f0;
}

.modern-table ::v-deep table {
  min-width: 950px;
  width: 100%;
}

/* Sticky primera columna (Opc. / Acciones) */
.modern-table ::v-deep thead th:first-child {
  position: sticky !important;
  left: 0 !important;
  z-index: 4 !important;
  background-color: #424242 !important;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.15) !important;
}

.modern-table ::v-deep tbody tr td:first-child {
  position: sticky !important;
  left: 0 !important;
  z-index: 2 !important;
  background-color: #ffffff !important;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.06) !important;
}

.modern-table ::v-deep tbody tr:hover td:first-child {
  background-color: #f8fafc !important;
}

.modern-table ::v-deep tbody tr.bg-gray-light td:first-child {
  background-color: #ffe7a9 !important;
}

.modern-table ::v-deep thead tr:not(.v-data-table__progress) th {
  background-color: #424242 !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  font-size: 0.8rem !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  white-space: nowrap;
  border-bottom: 2px solid #212121 !important;
  border-right: 1px solid rgba(255, 255, 255, 0.12) !important;
  padding: 10px 14px !important;
  height: 42px !important;
}

.modern-table
  ::v-deep
  thead
  tr:not(.v-data-table__progress)
  th
  .v-data-table-header__icon {
  color: #ffffff !important;
}

.modern-table ::v-deep thead tr:not(.v-data-table__progress) th span {
  color: #ffffff !important;
}

.modern-table ::v-deep .v-data-table__progress th {
  background: transparent !important;
  background-color: transparent !important;
  border: none !important;
  padding: 0 !important;
  height: auto !important;
}

.modern-table ::v-deep .v-data-table__empty-wrapper td {
  background: transparent !important;
  background-color: transparent !important;
}

.modern-table ::v-deep td {
  font-size: 0.85rem !important;
  padding: 8px 14px !important;
  border-bottom: 1px solid #f1f5f9 !important;
  vertical-align: middle;
}

.modern-table ::v-deep tbody tr:hover {
  background-color: #f8fafc !important;
  transition: background-color 0.15s ease-in-out;
}

.modern-table ::v-deep .v-data-footer {
  border-top: 1px solid #e2e8f0;
  background-color: #f8fafc;
  font-size: 0.82rem;
  padding: 8px 16px;
}

.table-responsive-wrapper {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table-responsive-wrapper::-webkit-scrollbar {
  height: 6px;
}

.table-responsive-wrapper::-webkit-scrollbar-track {
  background: #f1f5f9;
}

.table-responsive-wrapper::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.table-responsive-wrapper::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.action-btn {
  transition: transform 0.18s ease-in-out, box-shadow 0.18s ease-in-out !important;
}

.action-btn:hover {
  transform: scale(1.1) !important;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2) !important;
}

.gap-1 {
  gap: 4px;
}

.btn-circle-tooltip {
  background: rgba(255, 255, 255, 0.16) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  border-radius: 50% !important;
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  max-width: 36px !important;
  padding: 0 !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-decoration: none !important;
  transition: all 0.2s ease-in-out !important;
}

.btn-circle-tooltip ::v-deep .v-btn__content {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  height: 100% !important;
  line-height: 1 !important;
}

.btn-circle-tooltip ::v-deep .v-icon {
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.btn-circle-tooltip:hover {
  background: rgba(255, 255, 255, 0.28) !important;
  border-color: rgba(255, 255, 255, 0.45) !important;
}

/* ============================================================
   RESPONSIVE: Mobile (max 600px)
   ============================================================ */
@media (max-width: 600px) {
  .table-header-toolbar {
    min-height: 48px;
  }

  .table-header-toolbar ::v-deep .v-toolbar__content {
    padding: 6px 10px !important;
  }

  .header-icon-box {
    width: 32px;
    height: 32px;
    min-width: 32px;
    border-radius: 6px;
  }

  .header-icon-box .v-icon {
    font-size: 18px !important;
  }

  .header-company-title {
    font-size: 0.88rem !important;
    line-height: 1.2;
  }

  .header-count-chip {
    font-size: 0.75rem !important;
    height: 24px !important;
    padding: 0 6px !important;
  }

  .header-count-chip .v-icon {
    font-size: 14px !important;
    margin-right: 2px !important;
  }

  .action-buttons-group {
    width: 100% !important;
    display: flex !important;
    flex-direction: column !important;
    gap: 8px !important;
  }

  .btn-action-header {
    width: 100% !important;
    max-width: 100% !important;
    justify-content: center !important;
    margin-right: 0 !important;
  }

  .action-buttons-group .v-menu {
    width: 100% !important;
    display: block !important;
  }

  .modern-table ::v-deep thead th {
    font-size: 0.72rem !important;
    padding: 8px 10px !important;
    height: 38px !important;
  }

  .modern-table ::v-deep td {
    font-size: 0.78rem !important;
    padding: 6px 10px !important;
  }

  .modern-table ::v-deep .v-data-footer {
    flex-wrap: wrap;
    justify-content: center;
    padding: 8px 6px;
    gap: 6px;
  }

  .modern-table ::v-deep .v-data-footer__select {
    margin-right: 6px;
  }

  .modern-table ::v-deep .v-data-footer__pagination {
    margin: 0 4px;
  }
}
</style>
